// config.js - Updated for Backblaze B2
export const baseUrl = "https://producerbuddygateway.vercel.app"
// ✅ Updated to Backblaze B2 public URL
export const R2_PUBLIC_URL = "https://f005.backblazeb2.com/file/producerbudddyfiles"

export const FILE_SERVICE_URL = "https://file-storage-service-lake.vercel.app/"

// Production URLs (uncomment when deploying)
// export const baseUrl = "https://producerbuddygateway.vercel.app"
// export const R2_PUBLIC_URL = "https://f005.backblazeb2.com/file/producerbudddyfiles"
// export const FILE_SERVICE_URL = "https://your-file-service.vercel.app"
// For  Local Developments == http://127.0.0.1:8000
